import React from "react";
import { Card, CardContent } from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import { t } from "i18next";

export default function Cashback() {
  return (
    <Card className="w-full">
      <CardContent className="p-4 space-y-4">
        <div className="flex justify-center items-center">
          <img
            src="/assets/cashback.gif"
            alt="QR Code"
            className="w-[8rem] h-[8rem] md:w-[12rem] md:h-[12rem]"
          />
        </div>
        <Card>
          <CardContent>
            <Label className="font-semibold text-center flex items-center justify-center">
              {t("order_history.did_you_know")}
            </Label>
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  );
}
